/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class FilterOptionsLight {
    getFixupPrototypeFunction() { return FilterOptionsLight.fixupPrototype; }

    static newInstance(model: Partial<FilterOptionsLight>): FilterOptionsLight {
        let obj = Object.assign(new FilterOptionsLight(), model);
        FilterOptionsLight.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<FilterOptionsLight>): FilterOptionsLight {
        if (!model) return null;
        return FilterOptionsLight.newInstance(<FilterOptionsLight> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: FilterOptionsLight) {
        if (!obj) return;

        models.FilterOptionsLight.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: FilterOptionsLight): boolean {
        Object.setPrototypeOf(obj, FilterOptionsLight.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.tenants) {
            for (let val of this.tenants) {
                models.FilterOptionsTenantLight.fixupPrototype(val);
            }
        }
    }

    tenants: Array<models.FilterOptionsTenantLight>;

}
